<template>
  <header class="header">
    <a href="https://www.grenfellunited.org/" target="_blank">
      <img src="../assets/logo_dark.png" alt="Grenfell United" class="logo" v-if="!white">
      <img src="../assets/logo.png" alt="Grenfell United" class="logo" v-if="white">
    </a>
  </header>
</template>

<script>
export default {
  name: "Header",
  props: ["white", "center"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  max-width: 1170px;
  margin: 0 auto;
  text-align: center;
  padding: 5px 0;
  .logo {
    max-width: 80px;
  }
}
</style>
